import React from 'react';
import {Formik, Field, FormikProps, ErrorMessage, FormikHelpers} from 'formik';

import {Button, Form, Popup} from '@components';
import utils from '@utils';
import mappings from '@mappings';
import validations from '@validations';
import {Props} from './types';
import * as handlers from './handlers';
import constants from '@constants';

import './index.scss';

const Main: React.FC<Props> = props => {
  const initialValues = {
    disasterType: null,
    prefecture: null,
    intensity: 0,
    isEmailSending: true,
    isSMSSending: false,
    isConnectSending: false,
    message: '',
  };

  return (
    <div className="a__send">
      <div className="b__title">手動送信</div>
      <div className="w__field">
        <div className="b__field">
          <Form.Label text="災害" required />
          <Formik
            initialValues={initialValues}
            onSubmit={(value: any, formikHelpers: FormikHelpers<any>) => {
              handlers.send(
                value,
                formikHelpers,
                props.me.teamId,
                props,
                props.me.id
              );
            }}
            validate={validations.notifications.create}
          >
            {(formProps: FormikProps<any>) => {
              return (
                <>
                  <div className="w__selection">
                    <Field
                      component={Form.Dropdown}
                      name="disasterType"
                      options={utils.mappings.createSelections(
                        mappings.disasters
                      )}
                    />
                  </div>
                  <Form.Label text="地域" required />
                  <div className="w__selection">
                    <Field
                      component={Form.Dropdown}
                      name="prefecture"
                      options={utils.mappings.createSelections(
                        mappings.prefectures
                      )}
                    />
                  </div>
                  <Form.Label text="通知手段" required />
                  <div className="w__checkbox">
                    <div className="w__field">
                      <Field
                        component={Form.Checkbox}
                        label="メール"
                        name="isEmailSending"
                        disabled={props.me.plan === constants.PLAN.FREE}
                      />
                      <Field
                        component={Form.Checkbox}
                        label="SMS"
                        name="isSMSSending"
                        disabled={props.me.plan < constants.PLAN.SAFETY}
                      />
                      <Field
                        component={Form.Checkbox}
                        label="電話"
                        name="isConnectSending"
                        disabled={props.me.plan < constants.PLAN.SAFETY_X}
                      />
                      {props.me.plan === constants.PLAN.FREE && (
                        <Popup.Normal content="無料プランでは、Eメールでのみ安否確認を送信できます" />
                      )}
                      {props.me.plan === constants.PLAN.SAFETY && (
                        <Popup.Normal content="スタンダードプランではEメールまたはSMSで安否確認を送信できます" />
                      )}
                    </div>
                    <ErrorMessage
                      name="isEmailSending"
                      component={Form.Error}
                    />
                  </div>

                  <Form.Label text="メッセージ" required />
                  <Field
                    component={Form.TextArea}
                    name="message"
                    placeholder="メッセージを入力してください"
                  />
                  <div className="w__setting-button">
                    <Button.Normal
                      color="yellow"
                      text="送信する"
                      disabled={formProps.isSubmitting}
                      loading={formProps.isSubmitting}
                      onClick={() => formProps.handleSubmit()}
                    />
                  </div>
                </>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default Main;
